import * as React from "react";
const SvgFiRrPompebled = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pompebled_svg__a)">
      <path
        fill="#062147"
        d="M9.945 24c-2.948 0-5.472-.931-7.243-2.703C.524 19.12-.385 15.805.142 11.964.618 8.518 2.23 5.13 4.459 2.902L5.79 1.569A5.32 5.32 0 0 1 9.579 0c1.43 0 2.777.558 3.789 1.569 1.022 1.022 1.567 2.162 1.62 3.387.052 1.169-.741 2.692-1.606 4.164-.452.77-.51 1.332-.17 1.67.333.334.896.273 1.669-.181 1.472-.865 3.009-1.657 4.163-1.607 1.226.053 2.365.598 3.387 1.621A5.32 5.32 0 0 1 24 14.412a5.32 5.32 0 0 1-1.57 3.788l-1.332 1.333c-2.23 2.229-5.616 3.844-9.061 4.319Q10.96 24 9.946 24zM9.579 2.001c-.86 0-1.72.328-2.375.982L5.87 4.316c-1.931 1.931-3.332 4.891-3.748 7.92-.441 3.207.267 5.922 1.992 7.647 1.724 1.725 4.439 2.432 7.646 1.987 3.028-.418 5.989-1.821 7.92-3.752l1.334-1.333a3.36 3.36 0 0 0 0-4.749c-.667-.667-1.34-1.005-2.06-1.037-.505-.025-1.521.427-3.063 1.334-1.59.933-3.082.886-4.097-.129-1.02-1.02-1.071-2.514-.14-4.099.906-1.542 1.355-2.572 1.333-3.063-.031-.72-.37-1.394-1.037-2.06A3.35 3.35 0 0 0 9.577 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pompebled_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPompebled;
